import * as React from 'react';

import { cn } from '@/lib/core';
import { Label } from './label';

interface FormFieldProps {
  id: string;
  label?: string;
  helpText?: string;
  error?: string;
  required?: boolean;
  children: React.ReactNode;
  className?: string;
}

function FormField({ id, label, helpText, error, required, children, className }: FormFieldProps) {
  return (
    <div data-slot="form-field" className={cn('font-inter flex flex-col gap-1', className)}>
      {label && (
        <Label htmlFor={id}>
          {label}
          {required && (
            <span aria-hidden="true" className="text-jncquoi-neutral-1000 ml-0.5">
              *
            </span>
          )}
        </Label>
      )}
      {children}
      {helpText && !error && (
        <p data-slot="form-field-help" className="text-muted-foreground text-xs">
          {helpText}
        </p>
      )}
      {error && (
        <p data-slot="form-field-error" role="alert" className="text-jncquoi-asia-7427c-500 text-xs">
          {error}
        </p>
      )}
    </div>
  );
}

export { FormField };
export type { FormFieldProps };
